import { render, staticRenderFns } from "./GmbNoReviewLocations.vue?vue&type=template&id=79b61eba&scoped=true"
import script from "./GmbNoReviewLocations.vue?vue&type=script&lang=js"
export * from "./GmbNoReviewLocations.vue?vue&type=script&lang=js"
import style0 from "./GmbNoReviewLocations.vue?vue&type=style&index=0&id=79b61eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b61eba",
  null
  
)

export default component.exports